import { render } from "./AdDocumentPromotion.vue?vue&type=template&id=0560344e&ts=true"
import script from "./AdDocumentPromotion.vue?vue&type=script&lang=ts"
export * from "./AdDocumentPromotion.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__